enum TagType {
  COMPANY = 1,
  CONTACT = 2,
  OPPORTUNITY = 3,
  PRODUCT = 4,
  ORDER = 5
}

export function tagTypeToAdditionalFieldColumnType(type: TagType): string {
	switch (type) {
		case TagType.COMPANY: return 'Company';
		default: return '';
	}
}

interface TagEditParams {
  ressource_id: number
  ids_delete?: number[]
  ids_add?: number[]
}

export {
	TagEditParams,
	TagType
};
